import React, { useState } from 'react';
import StateBasedFadeTransition from '@components/transitions/StateBasedFadeTransition';
import styles from './EmailConfirmation.module.scss';
import { completeEmailAuthWorkflow } from '@repo/utils/helpers/jwt';
import { lastValueFrom } from 'rxjs';
import { LoaderIcon } from '@repo/icons';
import { ToggleButton } from '@components/Login/Buttons';
import { LoginButton } from '@repo/components/buttons';
import TextInput from '@components/Login/TextInput';
import { GenericError } from '@components/Login/EmailConfirmation/Errors';

export default function EmailConfirmation({
  loginEmailRecipient,
}: {
  loginEmailRecipient: string;
}) {
  const [loginCode, setLoginCode] = useState('');
  const [error, setError] = useState(undefined);
  const [enteringCode, setEnteringCode] = useState(false);
  const [saving, setSaving] = useState(false);

  const login = () => {
    setSaving(true);
    setError(undefined);
    lastValueFrom(completeEmailAuthWorkflow(loginCode, loginEmailRecipient, false))
      .then(() => {
        window.location.href = '/';
      })
      .catch((e) => {
        setSaving(false);
        setError(e.status);
        console.error(e);
      });
  };

  const loginWithCode = () => {
    login();
  };

  let errorUI = <GenericError />;

  return (
    <div className={styles.emailConfirmation}>
      <StateBasedFadeTransition
        state={String(!!error)}
        elementByStateMap={{
          false: (
            <div className={styles.message}>
              <p>
                Thank you for signing up for Clay
                <br />
                via AppSumo.
              </p>
              <p>
                We have sent a sign in link to your
                <br />
                email. Check your inbox at
                <br />
                <b>{loginEmailRecipient}</b>.
              </p>
            </div>
          ),
          true: <p>{errorUI}</p>,
        }}
      />
      <StateBasedFadeTransition
        state={String(enteringCode)}
        elementByStateMap={{
          false: (
            <span>
              <ToggleButton onClick={() => setEnteringCode(true)}>Enter code manually</ToggleButton>
            </span>
          ),
          true: (
            <span>
              <TextInput
                value={loginCode}
                onChange={(e) => setLoginCode(e.target.value)}
                placeholder="Enter code"
                invalidValueMsg="Please enter a valid code"
                validateValue={(value) => value.length == 8}
                onEnter={loginWithCode}
                autoFocus
              />
              <LoginButton
                className={styles.codeLoginBtn}
                onClick={loginWithCode}
                disabled={saving || loginCode.length != 8}
              >
                {!saving ? (
                  `Sign in with code`
                ) : (
                  <>
                    Signing in <LoaderIcon />
                  </>
                )}
              </LoginButton>
            </span>
          ),
        }}
      />
    </div>
  );
}
